export default class Localisation {
	static localisations = {
		en: {
			error404_title: "Error 404",
			error404_message: "The page you are looking for does not exist.",
		},
	};

	static singletons = {};

	static singleton(language) {
		if (!this.singletons[language]) {
			this.singletons[language] = new Localisation(
				language,
				this.localisations[language],
			);
		}
		return this.singletons[language];
	}

	constructor(language, localisations) {
		this.routes = {};
		this.language = language;
		this.localisations = localisations;
		this.detectRoutes();
		this._ = new Proxy(
			(text, values) => {
				return this.translate(text, values);
			},
			{
				get(func, arg) {
					return func(arg);
				},
			},
		);
	}

	/**
	 * Special syntax:
	 * values can be an array or object.
	 * {0} array: numbers inside braces will be replaced by their corresponding index in the array
	 * {:property} object: property names need to be prefixed with a colon inside braces
	 * @ prefix: if a values item is prefixed with @ it will be translated - useful when serving data that needs to be translated but display language is unknown (eg in notifications)
	 */
	translate(text, values) {
		if (typeof this.localisations[text] != 'undefined') {
			if (values) {
				if (typeof values == 'string' || typeof values == 'number') {
					values = [values];
				}
				text = this.localisations[text];
				if (Array.isArray(values)) {
					for (const key in values) {
						if (
							values[key] &&
							typeof values[key] == 'string' &&
							values[key].slice(0, 1) == '@'
						) {
							values[key] = this.translate(values[key].slice(1));
						}
						text = text.replace(
							new RegExp('\\{' + key + '\\}', 'gi'),
							values[key],
						);
					}
				} else if (typeof values == 'object') {
					for (let [key, value] of Object.entries(values)) {
						if (value && typeof value == 'string' && value.slice(0, 1) == '@') {
							value = this.translate(value.slice(1));
						}
						if (value !== null && value !== undefined) {
							text = text.replace(new RegExp('\\{:' + key + '\\}', 'gi'), String(value));
						}
					}
				}
				return text;
			} else {
				return this.localisations[text];
			}
		}
		if (text.slice(0, 1) == ':') {
			text = text.substr(1);
		}
		return text;
	}

	detectRoutes() {
		for (let name in this.localisations) {
			if (name.slice(0, 1) == ':') {
				this.routes[this.localisations[name]] = name.slice(1);
			}
		}
	}

	translateUrl(href) {
		if (href) {
			href = href.split('/');
			href.forEach((level, index) => {
				if (level.slice(0, 1) == ':') {
					href[index] = this.translate(level);
				}
			});
			href = href.join('/');
		}
		return href;
	}

	static parseHttpRequestLanguages(headersAcceptLanguageString) {
		if (headersAcceptLanguageString) {
			var accepted_languages = headersAcceptLanguageString.split(',');
			accepted_languages = accepted_languages.map(item => {
				item = item.split(';');
				if (item[1]) {
					item[1] = item[1].replace('q=', '');
				} else {
					item[1] = 1;
				}
				if (item[0].indexOf('-')) {
					item[0] = item[0].split('-')[0];
				}
				return item[0];
			});
		} else {
			accepted_languages = ['en'];
		}
		return accepted_languages;
	}

	static getLangFromHttpRequest(headersAcceptLanguageString) {
		let language, localisations;
		const languages = this.parseHttpRequestLanguages(
			headersAcceptLanguageString,
		);
		for (let i = 0; i < languages.length; i++) {
			if (typeof this.localisations[languages[i]] != 'undefined') {
				language = languages[i];
				localisations = this.localisations[languages[i]];
				break;
			}
		}
		typeof language == 'undefined' &&
			((localisations = this.localisations['en']), (language = 'en'));
		return { language, languages, localisations };
	}
}
